{
    "PaginatedList_Search": "Suche",
    "PaginatedList_Search_NoResults": "Es wurden keine Erweiterungen für diese Suche gefunden",
    "NAME": "PaginatedList"
}